"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.decorateOptionlistitem = void 0;
var _react = _interopRequireDefault(require("react"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _get = _interopRequireDefault(require("lodash/get"));
var _i18n = require("../../../../../../Framework/i18n");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = require("@material-ui/core/styles");
var _RuleComponent2 = require("../RuleComponent");
var _memoize = _interopRequireDefault(require("../../../../../../Utils/Function/memoize"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var optionlistitemStyles = function optionlistitemStyles() {
  return {
    root: {
      cursor: 'auto'
    },
    details: {
      display: 'none'
    }
  };
};
var decorateOptionlistitem = exports.decorateOptionlistitem = (0, _memoize["default"])(function (OptionlistitemComponent) {
  return (0, _styles.withStyles)(optionlistitemStyles, {
    name: 'OptionRuleOptionlistitem'
  })(function (props) {
    if (!OptionlistitemComponent) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(OptionlistitemComponent, _extends({}, props, {
      OptionAmountComponent: null
    }));
  });
});
var styles = function styles() {
  return {
    root: {},
    resolveText: {
      fontWeight: 'bold',
      paddingTop: 10
    }
  };
};
var OptionExclusionRule = /*#__PURE__*/function (_RuleComponent) {
  _inherits(OptionExclusionRule, _RuleComponent);
  var _super = _createSuper(OptionExclusionRule);
  function OptionExclusionRule(props) {
    var _this;
    _classCallCheck(this, OptionExclusionRule);
    _this = _super.call(this, props);
    _this.state = {
      result: {}
    };
    return _this;
  }
  _createClass(OptionExclusionRule, [{
    key: "initState",
    value: function initState(props) {
      var result = props.result;
      if (result) {
        this.setState({
          result: result
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initState(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this.initState(props);
    }
  }, {
    key: "renderInfoText",
    value: function renderInfoText() {
      var isReverseCheck = (0, _get["default"])(this.state.result, 'data.reverseCheck', false);
      var ruleType = isReverseCheck ? 'optionexclusionreverse' : 'optionexclusion';
      return (0, _i18n.T)("incompatibility.rules.".concat(ruleType, ".text"), {
        tag: _Typography["default"]
      });
    }
  }, {
    key: "renderResolveText",
    value: function renderResolveText() {
      var ruleType = this.ruleType,
        classes = this.props.classes;
      return (0, _i18n.T)("incompatibility.rules.".concat(ruleType, ".resolveText"), {
        tag: _Typography["default"],
        className: classes.resolveText
      });
    }
  }, {
    key: "renderRules",
    value: function renderRules() {
      var _this$props = this.props,
        Optionlistitem = _this$props.Optionlistitem,
        viewDetails = _this$props.viewDetails,
        checkedOptionIndex = _this$props.checkedOptionIndex,
        ruleTypeIndex = _this$props.ruleTypeIndex,
        classes = _this$props.classes;
      var _this$state$result = this.state.result,
        checked_option = _this$state$result.checked_option,
        conflicting_options = _this$state$result.conflicting_options;
      var OptionComponent = OptionExclusionRule.OptionComponent || decorateOptionlistitem(Optionlistitem);
      var isReverseCheck = (0, _get["default"])(this.state.result, 'data.reverseCheck', false);
      if (!OptionComponent) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.root
      }, checkedOptionIndex === 0 && isReverseCheck === false && /*#__PURE__*/_react["default"].createElement(OptionComponent, {
        option: checked_option,
        viewDetails: viewDetails,
        className: "checkedOption"
      }), ruleTypeIndex === 0 && this.renderInfoText(), ruleTypeIndex === 0 && this.renderResolveText(), (0, _isArray["default"])(conflicting_options) && conflicting_options.map(function (option, key) {
        return /*#__PURE__*/_react["default"].createElement(OptionComponent, {
          key: key,
          option: option,
          viewDetails: viewDetails,
          className: "conflictingOption"
        });
      }));
    }
  }]);
  return OptionExclusionRule;
}(_RuleComponent2.RuleComponent);
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'OptionExclusionRule'
})(OptionExclusionRule);